import React from 'react'
import { ArrowButton } from '@truphone/buttons'
import NewsAndPress from './NewsAndPress'
import ContentHubItem from './ContentHubItem'
import '../style.css'

export default function MenuCompany(props) {
  return (
    <div className="bg-white text-black relative overflow-hidden">
      <div className="container mx-auto px-6">
        <div className="flex justify-center">
          {props.sideMenu && (
            <div className="w-1/6 text-xs pt-6">
              <p className="mb-4 opacity-70 tracking-wide">{props.sideMenu.title}</p>
              {props.sideMenu.items &&
                props.sideMenu.items.map((link, i) => {
                  return (
                    <a
                      key={`about-link-${i}`}
                      className="block mb-2 hover:text-blue-100"
                      target={link.target}
                      title={link.title}
                      rel={link.rel}
                      href={link.href}
                    >
                      {link.text}
                    </a>
                  )
                })}
            </div>
          )}

          {props.newsroom && (
            <div
              className={`${
                props.events && props.events.items.length > 0 ? 'w-1/2' : 'w-3/4'
              } text-xs pt-6`}
            >
              <p className="mb-4 opacity-70 tracking-wide">{props.newsroom.title}</p>
              {props.newsroom.items && (
                <div className="flex flex-wrap">
                  {(props.events && props.events.items.length > 0
                    ? props.newsroom.items.slice(0, 6)
                    : props.newsroom.items.slice(0, 8)
                  ).map((link, i) => {
                    return (
                      <NewsAndPress
                        key={`news-and-press-${i}`}
                        {...link}
                        events={props.events && props.events.items.length > 0}
                      />
                    )
                  })}
                </div>
              )}
              {props.newsroom.seeAll && (
                <div className="py-3">
                  <ArrowButton
                    href={props.newsroom.seeAll.href}
                    className="text-blue-100 text-sm block"
                  >
                    {props.newsroom.seeAll.text}
                  </ArrowButton>
                </div>
              )}
            </div>
          )}

          {props.events && props.events.items.length > 0 && (
            <div
              className={`w-2/6 text-xs relative bg-grey-100 bg-grey-after pt-6 pl-6 ${
                props.events.seeAll ? '' : 'pb-6'
              }`}
            >
              <div className="relative z-1 flex flex-col h-full">
                <p className="mb-4 opacity-70 tracking-wide">{props.events.title}</p>
                {props.events.items && (
                  <div className="flex flex-wrap -m-2">
                    {props.events.items.slice(0, 2).map((link, i) => {
                      return <ContentHubItem key={`content-hub-${i}`} {...link} />
                    })}
                  </div>
                )}
                {props.events.seeAll && (
                  <div className="py-3 mt-auto">
                    <ArrowButton
                      href={props.events.seeAll.href}
                      className="text-blue-100 text-sm block"
                    >
                      {props.events.seeAll.text}
                    </ArrowButton>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
